import { render } from "./Wellness.vue?vue&type=template&id=6de7134e&scoped=true"
import script from "./Wellness.vue?vue&type=script&lang=js"
export * from "./Wellness.vue?vue&type=script&lang=js"

import "./Wellness.vue?vue&type=style&index=0&id=6de7134e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de7134e"]])

export default __exports__